import React from 'react';
import '../../App.css';
import languageMap from '../languageMap'; // Adjust the path based on your project structure

export default function Services() {
  const selectedLanguage = languageMap.config.selectedLanguage || 'en';

  return (
    <div>
      <h1 className='services'>
        {languageMap.servicesTitle[selectedLanguage]}
        <br />
        <br />
        <br />
        <br />
        <br />
        {languageMap.servicesDescription[selectedLanguage]}
      </h1>
      <p>{languageMap.welcomeMessage[selectedLanguage]} yos</p>
    </div>
  );
}
